import { FC } from "react";

import LobbyHeader from "./LobbyHeader/LobbyHeader";
import LobbyMain from "../../molecules/Lobby/LobbyMain";
import { CornerCirclesBackground } from "../../atoms";

const Lobby: FC<{}> = () => {

  return (
    <CornerCirclesBackground>
      <div className="lobby_wrapper">
        <LobbyHeader />

        <LobbyMain />
      </div>
    </CornerCirclesBackground>

  );
};

export default Lobby;
